// Possible values for Pre, Mid, Post Survet
export enum SurveyAvailability {
  MENTORS = "Mentors Only",
  MENTEES = "Mentees Only",
  BOTH = "Mentors and Mentees",
  NONE = "None",
}

// Possible values for the messageType field of the entity message
export enum MessageType {
  Question = "question",
  Answer = "answer",
  Statement = "statement",
  Clarification = "clarification",
  Response = "response",
  Gratitude = "gratitude",
  Mentorship = "mentorship",
  HiGnome = "hignome",
  HignomeChat = "hignome-chat",
}

// Possible values for the originalMediaType field of the entity message
export enum OriginalMediaType {
  Video = "video",
  Audio = "audio",
  Text = "text",
}

// Possible values for the nofiticationType field of the entity inboxNotifications
export enum NofiticationType {
  Message = "message",
  MessageReceiver = "messageReceiver",
  Reaction = "reaction",
  MentorshipReminder = "mentorshipReminder",
  NewMentorshipRequest = "newMentorshipRequest",
  NewMentorship = "newMentorship",
  SystemNotification = "systemNotification",
}

export enum StatusType {
  Requested = "requested",
  Accepted = "accepted",
  Declined = "declined",
}

export enum ReactionType {
  Like = "like",
  Helpful = "helpful",
  MeToo = "me-too",
  Flag = "flag",
  SavedMessage = "saved-message",
}

export enum RequestType {
  Mentorship = "mentorship",
  Following = "following",
}

export enum AnswerBasedOnType {
  EmergingResearch = "Emerging research",
  EstablishedEvidence = "Established evidence",
  Opinion = "Opinion",
  HiGnomeAI = "HiGnome AI",
}

export enum AttachmentType {
  Video = "video",
  Audio = "audio",
  Image = "image",
  URL = "url",
  PDF = "pdf",
}

export enum SurveyPrefixType {
  Pre = "pre",
  Mid = "mid",
  Post = "post",
}

export enum BadgeType {
  ProgramCompleted = "program-completed",
  MidpointCompletion = "midpoint-completion",
  FirstCheckIn = "first-check-in",
  FirstChimeIn = "first-chime-in",
  FirstReferral = "first-referral",
  FirstStatement = "first-statement",
  FirstGratitude = "first-gratitude",
  ThreeDayStreak = "three-day-streak",
  TenGritPoints = "ten-grit-points",
  ProfileCompleted = "profile-completed",
}

export enum CameraType {
  Front = "front",
  Back = "back",
}

export enum MatchingMethod {
  UserRequested = "userRequested",
  AdminManaged = "adminManaged",
}
